/**
 * This is the JS file for the auto alert creation on the website.
 */

/*
The first functions will catch the params in the query string and store it
in the local storage. The 2nd function will take care of sharing the alerts.
The last one will get all the product data so that it can be reused for the
popup.
*/

var idAutoAlert = null;
var nameAutoAlert = null;
var sourceAutoAlert = null;
var productData = null;

$(document).ready(function() {

  if (location.search) {
    console.log("params");
    var params = location.search.split("?")[1].split("&");
    for (var i in params) {
      var keyValue = params[i].split('=');
      if (keyValue[0] === 'id_autoalert') {
        if (keyValue[1] !== null && typeof keyValue[1] !== 'undefined') {
          localStorage.setItem('id_autoalert', keyValue[1]);
        }
      }
      if (keyValue[0] === 'name_autoalert') {
        if (keyValue[1] !== null && typeof keyValue[1] !== 'undefined') {
          localStorage.setItem('name_autoalert', keyValue[1]);
        }
      }
      if (keyValue[0] === 'source') {
        if (keyValue[1] !== null && typeof keyValue[1] !== 'undefined') {
          localStorage.setItem('source_autoalert', keyValue[1]);
        }
      }
    }
  }

  // set variables and store in local storage
  idAutoAlert = localStorage.getItem('id_autoalert');
  nameAutoAlert = localStorage.getItem('name_autoalert');
  sourceAutoAlert = localStorage.getItem('source_autoalert');

  if ((idAutoAlert || nameAutoAlert) && sourceAutoAlert) {
    console.log('has product data');
    getProducts(sourceAutoAlert, idAutoAlert, nameAutoAlert);
  }
});

// Share the alert if the params exist
function shareAutoAlerts(idUserShare) {
  if ((idAutoAlert || nameAutoAlert) && idUserShare && sourceAutoAlert){
    console.log('Share Alerts');
    $.ajax({
      url: '/wp-content/themes/mention/scripts/wp-auto-alerts.php?source='+sourceAutoAlert+'&id_auto_alert=' + (idAutoAlert === null ? "" : idAutoAlert) + '&name_auto_alert=' + (nameAutoAlert === null ? "" : nameAutoAlert) + '&id_user_share=' + (idUserShare === null ? "" : idUserShare),
      type: 'GET',
      dataType: 'json',
      headers: {
        'accept': 'application/json'
      },
      success: function(dataResponse){
        console.log('AutoAlerts Success:');
        console.log(dataResponse);
      },
      error: function(xhr, status, error) {
        var obj = $.parseJSON(xhr.responseText);
        var errorMsg = obj.message;
        console.log('AutoAlerts Error:');
        console.log(errorMsg);
      }
    });
    localStorage.removeItem('id_autoalert');
    localStorage.removeItem('name_autoalert');
    localStorage.removeItem('source_autoalert');
  }
}

// Get all the product data
function getProducts(source, id, name) {
  $.ajax({
    url: '/wp-content/themes/mention/scripts/wp-auto-alerts-products.php?source='+source+'&id_auto_alert='+(id === null ? "" : id)+'&name_auto_alert='+(name === null ? "" : name),
    type: 'GET',
    dataType: 'json'
  })
  .done(function(data) {
    productData = data;
    addAutoAlertInfos();
  })
  .fail(function(data) {
    console.log("getProduct failed");
    console.log(data.statusText);
  });
}

/*
Here we will display the alert messages and the info inside. The first function check if the container for the popup exist if it launches the popup and then modify the messages depending on the location.

The 2nd function inject HTML for the popup and set the trigger for closing.
*/

// Display the info for the alert inside the popup

function addAutoAlertInfos() {

  var name_product = "your product";
  var messagecta = "Monitor your product now";

  // Check if productData and fallback
  if (productData.status === "success") {
    name_product = productData.response[0].name;
    messagecta = "Monitor "+name_product+" now";
  }

  var messageTitle = 'Hey Product Hunter! Signup to get your alerts for '+ name_product +'.';
  var messageSubTitle = 'You are close to monitor your launch ;)';
  var messageDetail = 'Get your alerts';


  // is the announcement module in place?
  if ($('.men__announcement-cont').length) {
    addPopupAlert();
    $('.men__announcement, .men__announcement-logo').removeClass('hidden');
    $('.men__announcement').addClass('visible-left--flex');
    $('.men__announcement--ph .men__announcement-alert-title').text(messageTitle);
    $('.men__announcement--ph .men__announcement-alert-subtitle').text(messageSubTitle);
  }

  // are we on SU? if so change announce
  if ($('#men__su-first-step').length) {
    $('.men__announcement--ph .men__announcement-alert-title').text('Meoowhoo! Welcome!');
    $('.men__announcement--ph .men__announcement-alert-subtitle').text('You are almost done! You can close this anytime if you want ;)');
  }

  // Is the main CTA on home in place?
  if ($('#men__home-form-top').length) {
    $('#men__home-top-cta, #men__menu-nav-cta').text(messagecta);
  }
}

// Display the popup Alert
function addPopupAlert() {
  console.log("alert notif");

  var popupAlert = '<div class="men__announcement men__announcement--ph hidden"><div class="men__announcement-logo hidden"><img class="men__announcement-logo--ph" src="/wp-content/themes/mention/img/ph.png" alt=""></div><a href="./signup" class="men__announcement-alert-container"><p class="men__announcement-alert-title"></p><p class="men__announcement-alert-subtitle"></p></a><span class=".men__announcement-close men__announcement-close--ph">x</span></div>';

  $('.men__announcement-cont').append(popupAlert);

  $('.men__announcement-close--ph').on('click', function() {
    var closestPopup = $('.men__announcement--ph');
    closestPopup.removeClass('visible-left--flex');
    closestPopup.addClass('hidden');
  });
}
